import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Toolbar from '@material-ui/core/Toolbar';
import { Edit, translate, showNotification } from 'react-admin';
import { connect } from 'react-redux';

import dataProvider, { PROMOTE } from '~config/providers/dataProvider';

import AccionForm from '../../Acciones/AccionForm';

/** Flatten a DRF validation-error object into a readable single-line message. */
function formatPromotionErrors(data) {
  if (!data || typeof data !== 'object') {
    return 'No se pudo convertir el borrador.';
  }
  const lines = Object.keys(data).map(field => {
    const value = data[field];
    const msg = Array.isArray(value) ? value.join(', ') : value;
    return `${field}: ${msg}`;
  });
  return `Faltan datos: ${lines.join(' | ')}`;
}

class DraftPromoteActions extends Component {
  state = { promoting: false };

  handlePromote = () => {
    this.setState({ promoting: true });
    dataProvider(PROMOTE, 'draft-actions', { id: this.props.id })
      .then(response => {
        const code = response && response.data ? response.data.code : null;
        // The draft is gone; go to the new (unpublished) accion, or the list.
        window.location = code ? `/#/actions/${code}/show` : '/#/actions';
      })
      .catch(error => {
        this.setState({ promoting: false });
        const data = error && error.body ? error.body : (error && error.response ? error.response.data : null);
        // Non-blocking toast (never window.alert — it freezes the page).
        this.props.showNotification(formatPromotionErrors(data), 'warning');
      });
  };

  render() {
    const { translate: t } = this.props;
    return (
      <Toolbar style={{ float: 'right' }}>
        <Button color="primary" onClick={this.handlePromote} disabled={this.state.promoting}>
          {t('buttons.promote')}
        </Button>
      </Toolbar>
    );
  }
}

const TranslatedDraftPromoteActions = connect(null, { showNotification })(translate(DraftPromoteActions));

function AccionBorradorEdit(props) {
  return (
    <Edit
      undoable={false}
      actions={<TranslatedDraftPromoteActions id={props.id} />}
      {...props}
    >
      <AccionForm draft />
    </Edit>
  );
}

export default AccionBorradorEdit;
